import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// customer_contacts — ช่องทางติดต่อลูกค้า (sales-owned child table)
// ============================================================================
export const customerContacts = sqliteTable("sales_customer_contacts", {
  id: text("id").primaryKey(), // ULID; preserved from accounting_partner_contacts during backfill
  customerId: text("customer_id").notNull(),
  channelId: text("channel_id").notNull(),
  contactValue: text("contact_value").notNull(),
  isPrimary: integer("is_primary").notNull().default(0),
  notes: text("notes"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  customerIdx: index("sales_customer_contact_customer_idx").on(table.customerId),
  customerDeletedIdx: index("sales_customer_contact_customer_deleted_idx").on(
    table.customerId,
    table.deletedAt,
  ),
}));

export type CustomerContact = typeof customerContacts.$inferSelect;
export type NewCustomerContact = typeof customerContacts.$inferInsert;
